/**
 *
 * Description 融合待编
 * Author: Qian.qianchen 2019-03-15
 */
'use strict';
angular.module('fusionPendingModule', ['appOperationBtnsModule', 'newspaperOperationBtnsModule', 'websiteOperationBtnsModule', 'wechatOperationBtnsModule', 'weiboOperationBtnsModule', 'appPendingTableModule', 'newspaperPendingTableModule', 'websitePendingTableModule', 'wechatPendingTableModule', 'weiboPendingTableModule', 'trillPendingTableModule', 'trillOperationBtnsModule', 'baijiahaoOperationBtnsModule', 'baijiahaoPendingTableModule', 'qiehaoPendingTableModule', 'qiehaoOperationBtnsModule', 'toutiaoPendingTableModule', 'toutiaoOperationBtnsModule'])
    .controller('fusionPendingCtrl', ['$scope', 'trsHttpService', 'modalDialog', '$q', 'localStorageService', '$filter', 'trsspliceString', '$window', 'editingCenterService', 'iWoService', 'forFusionSign', 'publicToolService',
        function ($scope, trsHttpService, modalDialog, $q, localStorageService, $filter, trsspliceString, $window, editingCenterService, iWoService, forFusionSign, publicToolService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.status = {
                    isPending: true,
                    showChannelChoose: false,
                    showMediaType: '', // 展示对应渠道
                    OprTime: '',
                    DocType: ''
                };
                $scope.data = {
                    customConfig: {
                        singleDatePicker: true, // 是否是单选框
                    },
                    selectedChannel: [],
                    selectedMediaArr: [], // 选择的渠道
                    channelsArray: [], // 下拉框产品数组
                    orderArray: editingCenterService.getNewspaperOrder(), // 下拉框排序
                    selectedOrder: editingCenterService.getNewspaperOrder()[0],
                    mediaTypesArray: [], // 渠道按钮
                    keywords: '',
                    items: [],
                    selectedArr: [],
                    banmianArray: [
                        {
                            name: '全部版面',
                            value: ''
                        }
                    ],
                };
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                initMediaTypes();
                var fusionPendingShowProduct = JSON.parse(localStorageService.get('fusionPendingShowProduct'));
                if (fusionPendingShowProduct) {
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        var property = $scope.data.items[i].MEDIATYPE === '5' ? 'ACCOUNTID' : $scope.data.items[i].MEDIATYPE === '4' ? 'CHANNELID' : 'SITEID';
                        if ($scope.data.items[i][property] === fusionPendingShowProduct.ObjectId) {
                            $scope.data.showProduct = $scope.data.items[i];
                            return;
                        }
                    }
                }
                $scope.data.showProduct = $scope.data.items[0];
                // getProductList().then(function () {
                //     var fusionPendingShowProduct = JSON.parse(localStorageService.get('fusionPendingShowProduct'));
                //     if (fusionPendingShowProduct) {
                //         for (var i = 0; i < $scope.data.items.length; i++) {
                //             var property = $scope.data.items[i].MEDIATYPE == '5' ? 'ACCOUNTID' : $scope.data.items[i].MEDIATYPE == '4' ? 'CHANNELID' : 'SITEID';
                //             if ($scope.data.items[i][property] == fusionPendingShowProduct.ObjectId) {
                //                 $scope.data.showProduct = $scope.data.items[i];
                //                 return;
                //             }
                //         }
                //     }
                //     $scope.data.showProduct = $scope.data.items[0];
                // });
            }

            /**
             * [initDropDown ]
             *
             * @return  {[type]}  [return description]
             */
            function initDropDown() {
                $scope.data.selectedChannel = $scope.data.channelsArray[0];
                $scope.data.selectedBanmian = $scope.data.banmianArray[0];
            }

            /**
             * [initMediaTypes 请求顶部渠道]
             *
             * @return  {[type]}  [return description]
             */
            function initMediaTypes() {
                $scope.loadingPromise = iWoService.getProducts().then((data) => {
                    $scope.data.mediaTypesArray = data;
                    $scope.data.selectedMediaArr.push(data[0]);
                    forFusionSign.getCountAndBindType($scope.data.mediaTypesArray);
                });
            }

            /**
             * [getProductList description] 获取产品列表数据
             * @return {[type]} [description]
             */
            // function getProductList() {
            //     var deffer = $q.defer();
            //     var params = {
            //         serviceid: 'mlf_fusion',
            //         methodname: 'queryDocumentsInDaiBianForPC',
            //         PageSize: $scope.page.PAGESIZE,
            //         OprTime: $scope.status.OprTime,
            //         DocType: $scope.status.DocType,
            //         OprTimeStart: angular.isDefined($scope.data.fromdate) ? $scope.data.fromdate : '',
            //         OprTimeEnd: angular.isDefined($scope.data.untildate) ? $scope.data.untildate : ''
            //     };
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
            //         $scope.data.items = [];
            //         data.forEach(function (item, index) {
            //             if (item.DOCCOUNT > 0) {
            //                 $scope.data.items.push(item);
            //             }
            //         });
            //         deffer.resolve();
            //     });
            //     return deffer.promise;
            // }

            /**
             * [selectProduct description] 产品选择
             * @param  {[object]} product [description] 产品
             * @return {[type]}         [description]
             */
            $scope.selectProduct = function (product) {
                if ($scope.isSelectedProduct(product)) {
                    $scope.data.showProduct = '';
                    return;
                }
                $scope.data.showProduct = product;
                $scope.page.PAGESIZE = 20;
                $scope.status.OprTime = '';
                localStorageService.set('fusionPendingShowProduct', JSON.stringify({ ObjectId: $scope.data.showProduct.MEDIATYPE === '4' ? $scope.data.showProduct.CHANNELID : $scope.data.showProduct.MEDIATYPE === '5' ? $scope.data.showProduct.ACCOUNTID : $scope.data.showProduct.SITEID }));

            };

            /**
             * [timeSelect description] 时间筛选
             * @return {[type]} [description]
             */
            $scope.timeSelect = function () {
                $scope.page.CURRPAGE = 1;
                $scope.status.OprTime = '';
                $scope.reloadData();
            };
            $scope.queryByDropdown = function (type, value) {
                if (type === 'paper') {
                    $scope.data.channelValue = value;
                    getBanmian(value);
                    $scope.data.banmianValue = '';
                } else if (type === 'banmian') {
                    $scope.data.banmianValue = value;
                } else if (type === 'media') {
                    $scope.data.channelValue = value;
                }
                $scope.page.CURRPAGE = 1;
                $scope.reloadData();
            };

            /**
            * [getBanmian description]
            *
            * @param   {[type]}  value  [value description]
            *
            * @return  {[type]}         [return description]
            */
            function getBanmian(value) {
                var params = {
                    methodname: 'queryCaiBianBanMians',
                    serviceid: 'mlf_paper',
                    PaperId: value
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    $scope.data.banmianArray = [{
                        name: '全部版面',
                        value: ''
                    }];
                    $scope.data.banmianValue = '';
                    $scope.data.selectedBanmian = $scope.data.banmianArray[0];
                    data.forEach((item) => {
                        item.name = item.CHNLDESC;
                        item.value = item.CHANNELID;
                    });
                    $scope.data.banmianArray = $scope.data.banmianArray.concat(data);

                });
            }

            /**
             * [isSelected description] 判断选中的稿件是不是该栏目下
             * @param  {[object]}  product [description] 栏目产品
             * @return {Boolean}         [description]
             */
            $scope.isSelected = function (product) {
                if ($scope.data.selectedArr.length > 0) {
                    var mediaId = $scope.data.selectedArr[0].MEDIATYPE === '5' ? 'PUBLISHACCOUNTIDS' : $scope.data.selectedArr[0].MEDIATYPE === '4' ? 'CHANNELID' : 'SITEID';
                    if (angular.isDefined(product[mediaId]) && $scope.data.selectedArr[0][mediaId] === product[mediaId]) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            };

            /**
             * [exportDraft description]导出功能
             * @return {[type]} [description]
             */
            $scope.exportDraft = function () {
                var temp = $filter('pick')($scope.data.selectedArr, $scope.examDraftType);
                if (temp.length < 1) {
                    var params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArr, 'METADATAID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        $scope.data.selectedArr = [];
                    }, function (data) {
                        if (data.REPORTS[0].ISSUCCESS === 'true') {
                            $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            $scope.data.selectedArr = [];
                        }
                    });
                } else {
                    modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [examDraftType description]检验稿件类型
             * @param  {[obj]} elm [description]稿件的具体信息
             * @return {[type]}     [description]
             */
            $scope.examDraftType = function (elm) {
                if (angular.isDefined(elm)) {
                    return (elm.DOCTYPEID !== '1' && elm.DOCTYPEID !== '2');
                }
            };

            /**
             * [outSending description]外发功能
             * @return {[type]} [description]
             */
            $scope.outSending = function () {
                var temp = $filter('pick')($scope.data.selectedArr, $scope.examDraftType);
                if (temp.length < 1) {
                    editingCenterService.outSending('', function (result) {
                        outSendingDraft(result.selectItems);
                    });
                } else {
                    modalDialog.alertType('只能外发新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [outSendingDraft description]外发函数
             * @param  {[array]} items [description]外发服务的返回值
             * @return {[type]}       [description]
             */
            function outSendingDraft(items) {
                var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
                var draftids = trsspliceString.spliceString($scope.data.selectedArr, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_mailoutgoingOper',
                    methodname: 'appDaiBianSendEmail',
                    Emails: userids,
                    MetaDataIds: draftids
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                        $scope.reloadData();
                    });
                }, function () {
                    $scope.data.selectedArr = [];
                });
            }

            /**
             * [refresh description] 表格刷新
             * @param  {[object]} $event [description] 点击事件
             * @return {[type]}         [description]
             */
            $scope.refresh = function ($event) {
                if ($event) {
                    $event.stopPropagation();
                }
                $scope.$broadcast('refresh', true);
            };

            /**
             * [reloadData description]
             *
             * @param   {[type]}  flag  [flag description]
             * @param   {[type]}  true  [true description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.reloadData = function (flag = true) {
                if (flag) {
                    forFusionSign.getCountAndBindType($scope.data.mediaTypesArray);
                }
                $scope.refresh();
                // getProductList().then(function () {
                //     $scope.refresh();
                // });
            };

            /**
             * [isSelectedProduct description] 是否是选中产品
             * @param  {[type]}  product [description] 被选中的产品
             * @return {Boolean}         [description]
             */
            $scope.isSelectedProduct = function (product) {
                if (!$scope.data.showProduct) {return false;}
                var id = $scope.data.showProduct.CHANNELID || $scope.data.showProduct.SITEID || $scope.data.showProduct.ACCOUNTID;
                var id_ = product.CHANNELID || product.SITEID || product.ACCOUNTID;
                return $scope.data.showProduct.MEDIATYPE === product.MEDIATYPE && id === id_;
            };
            $scope.mediaChange = function (item) {
                $scope.data.selectedMediaArr = [];
                $scope.data.selectedMediaArr.push(item);
                if (item.MEDIANAME === '全部') {
                    $scope.status.showChannelChoose = false;
                    $scope.status.showMediaType = '';
                    $scope.page.CURRPAGE = 1;
                    return;
                }
                $scope.status.showChannelChoose = true;
                $scope.status.showMediaType = item.MEDIATYPE;
                if (item.SITES) {
                    item.SITES.forEach((site) => {
                        site.name = site.SITEDESC || site.CHNLDESC || site.ACCOUNTNAME;
                        site.value = site.CHANNELID || site.SITEID;
                    });
                }
                $scope.data.channelsArray = [];
                // $scope.data.initDropName = item.MEDIANAME;
                if (item.MEDIANAME !== '纸媒') {
                    $scope.data.channelsArray[0] = {
                        name: `请选择${item.MEDIANAME}`,
                        value: ''
                    };
                } else {
                    // 纸媒需要去除掉一级审核的报纸
                    item.SITES = item.SITES.filter((site) => site.ISDUOJISHEN === '1');
                }
                $scope.data.channelsArray = $scope.data.channelsArray.concat(item.SITES);
                initDropDown();
                // 要写在初始化之后
                if (item.MEDIANAME === '纸媒') {
                    getBanmian($scope.data.selectedChannel.value);
                }
                $scope.data.banmianValue = $scope.data.selectedBanmian.value;
                $scope.data.channelValue = $scope.data.selectedChannel.value;
                $scope.page.CURRPAGE = 1;
            };
            $scope.showSelectedMedia = function (node) {
                var deffer = $q.defer();
                dealNewsPaperDropDown(node).then((data) => {
                    deffer.resolve(data);
                });
                return deffer.promise;
            };

            /**
             * [dealNewsPaperDropDown description]
             *
             * @param   {[type]}  node  [node description]
             *
             * @return  {[type]}        [return description]
             */
            function dealNewsPaperDropDown(node) {
                var deffer = $q.defer();
                if (angular.isUndefined(node.SITEID)) {
                    var rootNode = $scope.data.channelsArray;
                    if ($scope.status.isFirstLevel) {
                        $scope.status.isFirstLevel = false;
                        deffer.resolve(rootNode);
                    } else {
                        deffer.resolve([]);
                    }

                } else {
                    var params = {
                        methodname: 'queryCaiBianBanMians',
                        serviceid: 'mlf_paper',
                        PaperId: node.SITEID
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                        let tempData = [];
                        data.forEach((item) => {
                            let paper = {
                                name: item.CHNLDESC,
                                value: item.SITEID
                            };
                            tempData.push(paper);
                        });
                        deffer.resolve(tempData);
                    });
                }
                return deffer.promise;
            }

            /**
             * [selectPageNum description]
             *
             * @param   {[type]}  flag  [flag description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.selectPageNum = function (flag) {
                $scope.reloadData(flag);
            };
        }
    ]);
